import { BiSolidVideos } from "react-icons/bi";
import { FaClipboardQuestion } from "react-icons/fa6";

function ItemList({ item, onDragStart, onDragOver, onDrop }) {
    return (
        <li
            className="p-4 my-4 transition-all duration-500 border border-gray-300 rounded-lg min-h-24 min-w-80 cursor-grab active:opacity-70 active:border-1 active:border-gray-500"
            draggable
            onDragStart={onDragStart}
            onDragOver={(e) => {
                e.preventDefault();
                onDragOver();
            }}
            onDrop={onDrop}
        >
            <div className="flex items-center">
                {item?.attributes?.type === "video" ? (
                    <BiSolidVideos className="text-3xl text-primary-color-primary" />
                ) : (
                    <FaClipboardQuestion className="text-3xl text-green-color" />
                )}
                <p className="font-medium text-md">{item?.attributes?.name}</p>
            </div>
        </li>
    );
}

export default ItemList;
